export const adminOrganizationsKeys = {
  all: [{ module: 'adminOrganizations' }] as const,
  options: () => [{ ...adminOrganizationsKeys.all[0], scope: 'options' }] as const,
  teams: (organizationId: string) => [{ ...adminOrganizationsKeys.all[0], scope: 'teams', organizationId }] as const,
};
